import { CdMarketplaceEntityType } from '@repo/supergraph/marketplace/bankingCdOffersMarketplaceSearch/types';

export function getDriverRange<T extends keyof CdMarketplaceEntityType>(
  cdOffers: CdMarketplaceEntityType[],
  key: T,
  getDisplayValue: (offer: CdMarketplaceEntityType) => string | undefined,
): string {
  const validOffers = cdOffers.filter(offer => !!offer[key]);

  if (validOffers.length === 0) return 'N/A';

  const minOffer = validOffers.reduce(
    (min, offer) => (offer[key]! < min[key]! ? offer : min),
    validOffers[0],
  );
  const maxOffer = validOffers.reduce(
    (max, offer) => (offer[key]! > max[key]! ? offer : max),
    validOffers[0],
  );

  const minValue = getDisplayValue(minOffer);
  const maxValue = getDisplayValue(maxOffer);

  return minOffer[key] === maxOffer[key] ? `${minValue}` : `${minValue} - ${maxValue}`;
}

export function getMinMinimumBalance(cdOffers: CdMarketplaceEntityType[]): string {
  const offersWithMininumBalance = Object.values(cdOffers).filter(
    offer => offer.minimumBalance !== undefined && offer.minimumBalance !== null,
  );

  if (offersWithMininumBalance.length === 0) return 'N/A';

  const minMinimumBalance = offersWithMininumBalance.reduce(
    (min, offer) => (offer.minimumBalance! < min.minimumBalance! ? offer : min),
    offersWithMininumBalance[0],
  );

  return minMinimumBalance.driverMinimumBalance?.value || 'N/A';
}
